import VDraggable from './src/index'
export default VDraggable
